import {VoucherTemplate} from "./voucherTemplate";

export class OrderVoucherItem {
    id: string;
    priceGross: number;
    priceGrossBeforeDiscount?: number = 0;
    priceNet: number;
    vatRate: number;
    quantity: number;
    owner: string;
    description: string;
    dedication: string;
    voucherTemplate: VoucherTemplate;
}
